import { useParams } from "react-router-dom";
import { Construction } from "lucide-react";
import { PageHeader } from "@/components/common";
import { useI18n } from "@/lib/i18n";

const MODULES = {
  documentary: ["Contrôles documentaires", "Documentary checks", 3, ["Checklist par sujet et statuts différenciés (conforme vérifié … non examiné)", "Référentiel juridique par pays, daté et validé humainement", "Analyse des écarts exigence → écart → action"]],
  evidence: ["Bibliothèque de preuves", "Evidence library", 3, ["Stockage objet privé, liste blanche d'extensions, limites de taille", "Classification, version, réviseur", "Lien preuve ↔ constat"]],
  findings: ["Constats & risques", "Findings & risks", 3, ["Brouillon → En revue → Approuvé / Rejeté", "Matrice 5×5 impact × probabilité à seuils configurables", "SWOT dérivée des seuls constats revus"]],
  reports: ["Rapports", "Reports", 4, ["Synthèse analytique brouillon à partir des données réelles", "DOCX/PDF, PPTX, XLSX avec approbation du chef de mission", "Attestation de revue de processus (pas d'accréditation)"]],
  actions: ["Plan d'action & Gantt", "Action plan & Gantt", 4, ["Actions liées aux constats, KPI, jalons, % avancement", "Gantt 90 jours / 12 mois / 3 ans", "Export Excel du suivi"]],
};

export default function Planned() {
  const { module } = useParams();
  const { lang, tx } = useI18n();
  const m = MODULES[module] || MODULES.findings;
  return (
    <div>
      <PageHeader eyebrow={`${tx("Jalon", "Milestone")} ${m[2]}`} title={lang === "fr" ? m[0] : m[1]} />
      <div className="card-surface p-6 max-w-2xl" data-testid="planned-module">
        <div className="flex items-center gap-2 text-amber-800 font-semibold"><Construction className="h-5 w-5" />{tx("NON IMPLÉMENTÉ — prévu au jalon", "NOT IMPLEMENTED — planned for milestone")} {m[2]}</div>
        <p className="text-sm text-slate-600 mt-2">{tx("Aucune fonctionnalité factice n'est exposée. Périmètre prévu :", "No fake functionality is exposed. Planned scope:")}</p>
        <ul className="list-disc pl-5 mt-2 text-sm text-slate-700 space-y-1">{m[3].map((x) => <li key={x}>{x}</li>)}</ul>
      </div>
    </div>
  );
}
